import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function DestinationsPage() {
  const destinations = [
    {
      country: 'France',
      flag: '🇫🇷',
      image: 'https://public.readdy.ai/ai/img_res/2b41073fa65cbd91be555d6dd6e3607e.jpg',
      advantages: [
        'Système éducatif réputé mondialement',
        'Grande diversité de formations disponibles',
        'Qualité exceptionnelle de l\'enseignement',
        'Coût réduit dans les établissements publics',
        'Conditions de vie étudiantes favorables',
        'Riche patrimoine culturel et historique'
      ],
      stats: [
        { label: 'Universités', value: '3500+' },
        { label: 'Étudiants internationaux', value: '370K+' },
        { label: 'Coût annuel moyen', value: '€200-€600' }
      ],
      color: 'from-blue-600 to-red-600'
    },
    {
      country: 'Canada',
      flag: '🇨🇦',
      image: 'https://readdy.ai/api/search-image?query=Toronto%20CN%20Tower%20Canada%20skyline%20modern%20city%20architecture%20beautiful%20autumn%20colors%20maple%20leaves%20university%20campus%20multicultural%20students%20diverse%20environment%20educational%20excellence%20clean%20simple%20background&width=800&height=600&seq=dest-canada-1&orientation=landscape',
      advantages: [
        'Programmes hautement professionnalisants',
        'Excellentes perspectives d\'emploi post-études',
        'Environnement multiculturel accueillant',
        'Processus d\'immigration attractif',
        'Qualité de vie exceptionnelle',
        'Possibilités de résidence permanente'
      ],
      stats: [
        { label: 'Universités', value: '200+' },
        { label: 'Étudiants internationaux', value: '640K+' },
        { label: 'Coût annuel moyen', value: 'CAD 15K-35K' }
      ],
      color: 'from-red-600 to-red-700'
    },
    {
      country: 'Belgique',
      flag: '🇧🇪',
      image: 'https://readdy.ai/api/search-image?query=Brussels%20Grand%20Place%20Belgium%20beautiful%20historic%20architecture%20European%20city%20cobblestone%20square%20university%20students%20walking%20elegant%20buildings%20cultural%20heritage%20educational%20destination%20simple%20clean%20background&width=800&height=600&seq=dest-belgium-1&orientation=landscape',
      advantages: [
        'Universités reconnues internationalement',
        'Cadre européen prestigieux',
        'Coût d\'études très accessible',
        'Installation simple pour francophones',
        'Proximité avec plusieurs pays européens',
        'Système éducatif de haute qualité'
      ],
      stats: [
        { label: 'Universités', value: '40+' },
        { label: 'Étudiants internationaux', value: '90K+' },
        { label: 'Coût annuel moyen', value: '€835-€4175' }
      ],
      color: 'from-yellow-500 to-red-600'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Nos Destinations</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            Découvrez les trois destinations phares pour vos études à l'étranger. Chacune offre des opportunités uniques adaptées à vos ambitions académiques et professionnelles.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {destinations.map((destination, index) => (
              <div key={index} className="bg-gray-50 rounded-3xl overflow-hidden shadow-xl">
                <div className={`bg-gradient-to-r ${destination.color} p-8 text-white`}>
                  <div className="flex items-center gap-4 mb-4">
                    <span className="text-6xl">{destination.flag}</span>
                    <h2 className="text-4xl font-bold">{destination.country}</h2>
                  </div>
                  <div className="grid grid-cols-3 gap-6 mt-8">
                    {destination.stats.map((stat, idx) => (
                      <div key={idx} className="text-center">
                        <div className="text-3xl font-bold mb-1">{stat.value}</div>
                        <div className="text-sm text-white/80">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
                  <div>
                    <img 
                      src={destination.image}
                      alt={`Études en ${destination.country} - EduGlobe Campus`}
                      title={`Destination ${destination.country}`}
                      className="w-full h-[400px] object-cover rounded-2xl shadow-lg"
                    />
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold text-[#003D82] mb-6">Pourquoi choisir {destination.country} ?</h3>
                    <ul className="space-y-4">
                      {destination.advantages.map((advantage, idx) => (
                        <li key={idx} className="flex items-start">
                          <i className="ri-checkbox-circle-fill text-[#FF6B35] text-2xl mr-3 mt-1 flex-shrink-0"></i>
                          <span className="text-gray-700 text-lg">{advantage}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#003D82] mb-4">Comment choisir votre destination ?</h2>
            <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                <i className="ri-compass-3-fill text-3xl text-[#FF6B35]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003D82] mb-3">Vos objectifs académiques</h3>
              <p className="text-gray-600">Identifiez le programme et la spécialisation qui correspondent à votre projet professionnel.</p>
            </div>

            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                <i className="ri-wallet-3-fill text-3xl text-[#FF6B35]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003D82] mb-3">Votre budget</h3>
              <p className="text-gray-600">Évaluez les coûts d'études et de vie pour choisir la destination la plus adaptée.</p>
            </div>

            <div className="bg-white rounded-xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mx-auto mb-4">
                <i className="ri-global-fill text-3xl text-[#FF6B35]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#003D82] mb-3">Vos préférences culturelles</h3>
              <p className="text-gray-600">Considérez l'environnement culturel et les opportunités post-études dans chaque pays.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#003D82] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Besoin d'aide pour choisir ?</h2>
          <p className="text-xl mb-8 text-white/90">
            Nos conseillers experts vous aident à identifier la destination idéale selon votre profil et vos ambitions.
          </p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-customer-service-2-fill mr-3 text-2xl"></i>
            Parler à un conseiller
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
